<template>
  <v-navigation-drawer app
                       absolute
                       v-model="drawer"
                       clipped
                       :mini-variant.sync="mini"
                       width="210"
                       height="100%">
    <v-list nav>
      <v-divider class="mt-1"></v-divider>
      <div class="d-flex">
        <v-btn icon
               @click.stop="mini = !mini"
               class="mt-1">
          <v-icon v-if="mini">mdi-chevron-double-right</v-icon>
          <v-icon v-else>mdi-chevron-double-left</v-icon>
        </v-btn>
        <v-breadcrumbs :items="breadItems"
                       large
                       v-show="!mini"
                       class="ma-n5">
          <template v-slot:divider>
            <v-icon>mdi-forward</v-icon>
          </template>
        </v-breadcrumbs>
      </div>
      <v-divider class="mt-1"></v-divider>
      <br>
      <!-- <v-list-item-group v-model="selectedItem"> -->
      <v-list-item v-for="(item, index) in items"
                   :key="index"
                   :to="item.path">
        <v-tooltip right>
          <template v-slot:activator="{on, attrs}">
            <v-icon v-bind="attrs"
                    v-on="on"
                    v-text="item.icon"
                    v-show="mini"></v-icon>
          </template>
          <span v-text="item.text"></span>
        </v-tooltip>
        <!-- <v-list-item-icon v-show="mini"> -->
        <!-- <v-icon v-text="item.icon"
                  v-show="mini"></v-icon> -->
        <!-- </v-list-item-icon> -->
        <!-- <v-list-item-content> -->
        <v-btn v-text="item.text"
               elevation="3"
               block
               text
               :class="{btnColor:selected==index}"
               class="font-weight-bold">
        </v-btn>
        <!-- </v-list-item-content> -->
      </v-list-item>
      <br>
      <v-divider></v-divider>
      <!-- </v-list-item-group> -->

      <!-- <v-list-group :prepend-icon="tools.icon"
                    :value="false">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title v-text="tools.text"></v-list-item-title>
          </v-list-item-content>
        </template> -->

      <!-- <v-timeline dense>
          <v-timeline-item v-for="tool in tools.toolsList"
                           :key="tool.text"
                           color="grey"
                           small>
            <v-list-item-content>
              <v-list-item-title v-text="tool.text"
                                 :to="tool.path"></v-list-item-title>
            </v-list-item-content>
          </v-timeline-item>
        </v-timeline> -->
      <!-- </v-list-group> -->
    </v-list>

    <br>
    <v-card class="mx-4 noclick"
            v-show="!mini">
      <div id="revolverMaps"></div>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import postscribe from 'postscribe';
export default {
  name: 'Drawer',
  data: () => ({
    // selectedItem: 0,
    selected: null,
    items: [
      { text: 'Home', icon: 'mdi-home-circle', path: '/home' },
      { text: 'Browse', icon: 'mdi-eye-circle', path: '/browse', },
      { text: 'Datasets', icon: 'mdi-database', path: '/dataset' },
      { text: 'Toolkit', icon: 'mdi-toolbox', path: '/tools', },
      { text: 'Download', icon: 'mdi-briefcase-download', path: '/download' },
      { text: 'Statistics', icon: 'mdi-chart-box', path: '/statistic' },
      { text: 'Help', icon: 'mdi-help-box', path: '/help' },
    ],
    // tools: {
    //   text: 'Tools', icon: 'mdi-toolbox', path: '/tools',
    // toolsList: [
    // { text: 'Introduction', path: '' },
    // { text: 'General', path: '' },
    // { text: 'Differential Expression Analysis', path: '/tools/dea' },
    // { text: 'Splice variants visualization', path: '' },
    // { text: 'Isoform Analysis', path: '' },
    // { text: 'Tumor-Normal PSI Difference', path: '' },
    // { text: 'Tissue-Specific PSI Difference', path: '' },
    // { text: 'Sashimi Plot', path: '' },
    // { text: 'PSI-Satge Plot', path: '' },
    // { text: 'Survival Analysis', path: '' },
    // { text: 'Correlation Analysis', path: '' },
    // { text: 'Similar Analysis', path: '' },
    // { text: 'Network Analysis', path: '' },
    // ]
    // },
    mini: true,
    breadItems: [],
  }),
  computed: {
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(val) {
        this.$store.commit('SET_DRAWER', val)
      },
    },
  },
  mounted() {
    postscribe('#revolverMaps',// Note: /script need to transform as \/script
      `<script type="text/javascript" src="//rf.revolvermaps.com/0/0/7.js?i=5d1ezjfzq7f&amp;m=0&amp;c=ff0000&amp;cr1=ffffff&amp;sx=0" async="async"><\/script>`)
  },
  watch: {
    $route(to, from) {
      // console.log(to);
      // console.log(to.path);
      // console.log(to.path.split('/')[1]);
      // if (to.path.split('/').length > 2) {
      //   console.log(to.path.split('/')[2]);
      // }
      this.changeBtnClass(to);
      this.changeBreadItems(to);
    }
  },
  methods: {
    changeBtnClass(to) {
      if (to.path.indexOf('home') !== -1) {
        this.selected = 0;
      } else if (to.path.indexOf('browse') !== -1) {
        this.selected = 1;
      } else if (to.path.indexOf('searchresult') !== -1) {
        this.selected = 1;
      } else if (to.path.indexOf('dataset') !== -1) {
        this.selected = 2;
      } else if (to.path.indexOf('tools') !== -1) {
        this.selected = 3;
      } else if (to.path.indexOf('download') !== -1) {
        this.selected = 4;
      } else if (to.path.indexOf('statistic') !== -1) {
        this.selected = 5;
      } else if (to.path.indexOf('help') !== -1) {
        this.selected = 6;
      }
    },
    changeBreadItems(to) {
      let breadItems = [];
      if (to.path.split('/').length == 2) {
        let breadItem
        let str = to.path.split('/')[1];
        if (to.path.split('/')[1] == "searchresult") {
          breadItem = {
            text: 'search',
            disabled: true,
          };
        } else {
          breadItem = {
            text: str.replace(str[0], str[0].toUpperCase()),
            disabled: false,
            href: '/ascancer' + to.path,
          };
        }
        breadItems.push(breadItem)
      } else if (to.path.split('/').length > 2) {
        let str1 = to.path.split('/')[1];
        let str2 = to.path.split('/')[2];
        let breadItem1 = {
          text: str1.replace(str1[0], str1[0].toUpperCase()),
          disabled: false,
          href: '/ascancer/' + to.path.split('/')[1],
        };
        let breadItem2 = {
          text: str2.replace(str2[0], str2[0].toUpperCase()),
          disabled: true,
        };
        breadItems.push(breadItem1, breadItem2)
      }
      this.breadItems = breadItems;
    }
  }
}
</script>

<style scoped>
.v-btn {
  text-transform: none;
}

/* change the button font size */
.v-btn.v-size--default {
  font-size: 1rem;
}

/* change the background-color of selected item when click it */
.v-list-item--link:before {
  background-color: white;
}

.btnColor {
  background-color: lightgray;
  color: #2196f3;
}

.noclick {
  pointer-events: none;
  cursor: none;
}
</style>